import { DeepPartial, PartialsConfig } from '@empathybroker/ebx-gluon';

export const MOBILE_PARTIALS: DeepPartial<PartialsConfig> = { components: { partial: { grid: 'EbxSlidingPanel' } } };
